import { Service } from '@roc/client-portal-shared/services';

const baseUrl = '/nportal/rest/pub/ecoa';

const url = {
  SEND_DENIAL_OF_CREDIT_REQUEST: `${baseUrl}/denialOfCredit`,
  CHECK_DENIAL_OF_CREDIT: `${baseUrl}/denialOfCreditExist`,
};

export class DenialOfCreditService extends Service {
  sendDenialOfCredit(loanId: string) {
    return this.get(
      url.SEND_DENIAL_OF_CREDIT_REQUEST,
      { loanId }
    );
  }

  checkDenialOfCreditExist(loanId: string){
    return this.get(
      url.CHECK_DENIAL_OF_CREDIT,
      { loanId }
    );
  }

}
